// src/frontend/data/books/DarkForest/data/cap21.js

const CAP21 = {
  id: 21,
  title: "Metodologías Avanzadas de Ataque en Web3",
  sections: [
    {
      heading: "Ataques avanzados: mucho más que phishing",
      text: [
        "Cuando hablamos de seguridad Web3, el público suele pensar únicamente en phishing. Sin embargo, existen metodologías de ataque mucho más elaboradas que combinan ingeniería social, malware personalizado, exploits de navegador, manipulación de DNS, falsificación de wallets, y ataques silenciosos tipo Man-in-the-Middle.",
        "Estas amenazas están especialmente enfocadas en el ecosistema cripto, diseñadas para robar claves privadas, frases semilla, credenciales y fondos, sin que la víctima siquiera detecte la intrusión."
      ]
    },
    {
      heading: "Caso Real: Documento señuelo que instala un troyano",
      text: [
        "En un caso reportado, los atacantes enviaron un correo con un documento titulado: 'A Huge Risk of Stablecoin (Protected).docx'.",
        "El título era atractivo y sugería contenido crítico e importante sobre el mundo cripto, lo que incentivó a investigadores, traders y fundadores a abrir el archivo.",
        "Al hacerlo, el archivo activaba macros de Office o exploits 0day/1day, instalando un troyano silencioso que ejecutaba múltiples acciones maliciosas."
      ],
      bulletPoints: [
        "📥 Recolección de credenciales (browser, SSH, exchange, wallet, VPN, etc.).",
        "⌨ Keyloggers para capturar contraseñas y frases semilla.",
        "📸 Capturas de pantalla y robo de archivos sensibles.",
        "🔐 Posible instalación de ransomware (pero en este caso no fue así).",
        "💣 Inyección de malware especializado para robar carteras cripto."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/d12cc9c9-c008-4c02-ac45-e475daacf905.png",
        alt: "Ejemplo de documento malicioso usado para infectar equipos",
        caption: "Los atacantes usan archivos legítimos para distribuir troyanos ocultos dirigidos al ecosistema cripto."
      }
    },

    {
      heading: "Ataques dirigidos a MetaMask o wallets instaladas",
      text: [
        "Según el análisis profesional (SecureList, Bluenoroff), el troyano reemplazaba la instalación legítima de MetaMask por una versión falsa con backdoor.",
        "Esto significa que el usuario seguía viendo su MetaMask normal, pero en segundo plano esa versión maliciosa manipulaba las direcciones de destino o enviaba la frase semilla al atacante.",
        "Incluso si la víctima usaba hardware wallet, el malware podía cambiar silenciosamente el monto o la dirección visible en la interfaz visual del navegador. Todo lo firmado parecía legítimo, pero los fondos iban al atacante."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/141606a7-5908-400b-8f72-9cdf9347050e.png",
        alt: "Esquema de ataque a MetaMask",
        caption: "Un MetaMask falsificado puede manipular direcciones, montos y autorizar operaciones sin que el usuario lo note."
      }
    },

    {
      heading: "Cuál es el patrón de este tipo de ataques?",
      text: [
        "Este enfoque no tiene como objetivo atacar a miles de usuarios, sino a perfiles específicos que manejan fondos importantes (traders, fundadores, miembros de DAOs, operadores de exchanges, auditores, coleccionistas de NFTs).",
        "Los atacantes estudian previamente a la víctima, su actividad, wallets públicas e incluso redes sociales. De ahí diseñan un ataque personalizado."
      ]
    },

    {
      heading: "Phishing masivo vs. Ataques dirigidos",
      text: [
        "🔹 Phishing masivo: criaturas genéricas, muy comunes, usan dominios falsos, anuncios en Google, tweets masivos, etc.",
        "🔹 Ataques dirigidos (Advanced Persistent Threat - APT): altamente personalizados, silenciosos, difíciles de detectar, y tienen objetivos específicos.",
        "Los ataques masivos son fáciles de evitar con un poco de cuidado, pero los ataques silenciosos, dirigidos y técnicos son extremadamente peligrosos."
      ]
    },

    {
      heading: "Técnicas avanzadas utilizadas (más allá del phishing)",
      text: [
        "Los atacantes de alto nivel combinan múltiples técnicas:"
      ],
      list: [
        " XSS (Cross-Site Scripting) para inyectar código a páginas legítimas.",
        " CSRF (Cross-Site Request Forgery) para ejecutar acciones sin tu permiso.",
        " Reverse Proxy: para interceptar tráfico hacia sitios reales.",
        " Manipulación DNS + BGP Hijacking.",
        " Implantación de malware persistente (RAT).",
        " Reemplazo de extensiones como MetaMask con versiones alteradas."
      ]
    },

    {
      heading: "Caso especial: Cloudflare como Man-in-the-Middle",
      text: [
        "Esto no significa que Cloudflare sea inseguro o malicioso. El problema es cuando el atacante compromete la cuenta del proyecto en Cloudflare.",
        "Una vez adentro, puede usar el módulo **Workers** para inyectar JavaScript malicioso directamente en el frontend del sitio web — sin modificar el servidor real del proyecto.",
        "Lo peligroso es que este ataque no genera errores HTTPS ni señales visuales. Ni el navegador, ni el usuario, ni el equipo técnico detectan la manipulación fácilmente."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/Blockchain-dark-forest-selfguard-handbook/refs/heads/main/res/cloudflare_worker.png",
        alt: "Diagrama de ataque usando Cloudflare Workers",
        caption: "Un atacante con acceso a Cloudflare puede inyectar código malicioso sin alterar el servidor original."
      }
    },

    {
      heading: "¿Por qué es tan difícil detectar este ataque?",
      text: [
        "🔹 No hay errores de certificado (HTTPS sigue funcionando).",
        "🔹 No hay alertas de seguridad visibles.",
        "🔹 Ni siquiera el equipo del proyecto detecta el problema rápidamente.",
        "🔹 El código malicioso se ejecuta DESPUÉS de la distribución CDN.",
        "🔹 Puede durar días o semanas antes de ser detectado."
      ]
    },

    {
      heading: "La importancia de la seguridad de cuentas",
      text: [
        "Estos ataques no sólo explotan vulnerabilidades técnicas, también se apoyan en fallos humanos:",
        "Mala gestión de contraseñas, falta de MFA (2FA), uso de correos vulnerables, claves API filtradas, etc.",
        "Una cuenta de Cloudflare, de GitHub, Google Drive, AWS o incluso Discord hackeada → puede permitir control total sobre un frontend, un repositorio o un contrato."
      ]
    },

    {
      heading: "Buenas prácticas para evitar ser víctima",
      text: [
        "✔ Nunca abras archivos Office con macros si provienen de fuentes dudosas.",
        "✔ Usa 2FA obligatoriamente (preferible autenticador, no SMS).",
        "✔ Revisa extensiones instaladas en tu navegador.",
        "✔ No descargues MetaMask/Trust Wallet desde plataformas no oficiales.",
        "✔ No uses la misma contraseña en más de un servicio.",
        "✔ Si eres fundador o administrador de proyectos cripto, usa computadoras dedicadas y aisladas."
      ]
    },

    {
      heading: "Cierre y aprendizaje",
      text: [
        "Este es un **dark forest**, un bosque oscuro. No es paranoia, es preparación.",
        "Cuantos más ejemplos hayas analizado –o peor aún, sufrido– más preparado estarás.",
        "Si te han hackeado alguna vez y sobreviviste, estás un paso más cerca de ser un verdadero profesional de la seguridad Web3.",
        "La seguridad no se aprende leyendo… se aprende sobreviviendo."
      ]
    }
  ]
};

export default CAP21;
